import { RiAlarmWarningLine } from "react-icons/ri";
import { useAlarms } from "../../contexts/alarms";
import "./CriticalAlarms.css";
import { AlarmActions } from "../AlarmActions/AlarmActions";
import { FinishBatchAlarms } from "../FinishBatchAlarms/FinishBatchAlarms";

export const CriticalAlarms = (props) => {
	const { alarms } = useAlarms()

	if (!alarms || !Array.isArray(alarms) || alarms.length === 0) {
		return (<div />);
	}

	return (
		<div className="critical-alarms">
			<div className="critical-alarms-content">
				<h2>
					<RiAlarmWarningLine size={36} />
					Alarmes críticos
					<span>{alarms.length}</span>
				</h2>
				{alarms && alarms.map((alarm, idx) => (
					<div key={idx} className="critical-alarm-card">
						<div className="info">
							<h4>{`${alarm.name}${alarm.data ? `: ${alarm.data}` : ''}`}</h4>
							<p>{alarm.target_name}</p>
						</div>
						<AlarmActions alarm={alarm} />
					</div>
				))}
				<div className="mt-4! w-fit! mx-auto!">
					<FinishBatchAlarms
						label={`Finalizar todos`}
						categories={alarms}
						onlyPresentEventNames={true} />
				</div>
			</div>
		</div>
	)
}